window.addEventListener("load", function(){  
    dx_logins_init();
});

function dx_logins_init(){
    var blocks = document.getElementsByClassName("wp-block-dx-login"); 
    for(var i = 0; i<blocks.length; i++){  
        dx_login_init(blocks[i]);
    }    
}    

function dx_login_init(block){    
    if(block.getAttribute("data-init")=="1"){
        return;
    }
    block.setAttribute("data-init", "1");

    if(block.getElementsByTagName("form").length==0){
        return; // disable when in gutenberg editor
    }        
    var span = block.getElementsByClassName("wp-block-dx-login-logout-username")[0];
    if(Dx.user.name){           
        span.innerHTML=Dx.user.name;
        block.getElementsByClassName("wp-block-dx-login-logout")[0].style.display="inline-block";
        block.getElementsByClassName("wp-block-dx-login-logout")[0].onclick=function(){ 
            window.open(Dx.url.logout, "_self");
        }
    } else {
        span.innerHTML='';
        block.getElementsByClassName("wp-block-dx-login-form")[0].style.display="block";            
    }        
    
}
function dx_logins_update(){
    var blocks = document.getElementsByClassName("wp-block-dx-login"); 
    for(var i = 0; i<blocks.length; i++){         
        dx_login_update(blocks[i]);               
    }  
}  
function dx_login_update(block){
}    
  
/*
function dx_logins_update(data){
    var blocks = document.getElementsByClassName("wp-block-dx-login");  
    for(var i = 0; i<blocks.length; i++){          
        if(data.user==null){        
            blocks[i].getElementsByClassName("wp-block-dx-login-form")[0].style.display="block";
            blocks[i].getElementsByClassName("wp-block-dx-login-logout")[0].style.display="none";
        } else {       
            blocks[i].getElementsByClassName("wp-block-dx-login-form")[0].style.display="none";
            blocks[i].getElementsByClassName("wp-block-dx-login-logout")[0].style.display="block";
        }
    }  
}
 */